<template>
    <div id="modal-search">
        <div class="popup-bg" @click.prevent="closeModal"></div>
        <div class="modal-box">
            <div class="close"><a href="#" @click.prevent="closeModal">&times;</a></div>
            <template v-if="result === null">
                <h2>Search for a Servicer</h2>
                <form ref="form" @submit.prevent="submit" novalidate>
                    <label for="street">Street Address: <small><em>Example: 123 Main (Omit St, Ave, etc.)</em></small></label>
                    <input type="text" id="street" v-model="search.address" name="Street_Address" placeholder="Required" required>
                    <div class="grid-x grid-padding-x">
                        <div class="small-12 medium-6 cell">
                            <label for="city">City: </label>
                            <input type="text" id="city" name=city>
                        </div>
                        <div class="small-12 medium-6 cell">
                            <label for="zip">ZIP Code: <small><em>Example: 19711</em></small></label>
                            <input type="text" id="zip" v-model="search.zipcode" name="ZIP" placeholder="Required" required>
                        </div>
                    </div>
                    <input type="checkbox" v-model="termsAgreed" id="terms" name="Terms_Agree" required> <label for="terms">I have read and agree to the <a href="/terms-of-service.html" target="_blank">Terms of Service</a></label>
                    <div class="must-agree" v-if="!termsAgreed && submitted">
                        Please indicate your agreement to the Terms of Service prior to submitting your search criteria.
                    </div>
                    <input type="submit" class="search-btn" value="Search">
                </form>
            </template>
            <template v-else>
                <div class="search-results">
                    <h2>Property Information</h2>
                    <div v-if="result !== null && result != 'none' && result != 'multiple'">
                        <h3>Property:</h3>
                        <div class="property">
                            <p>
                                <span>{{ result.address }}</span><br>
                                <span>{{ result.zipcode }}</span>
                            </p>
                        </div>
                        <h3>Servicer Name:</h3>
                        <div class="agent">
                            <p>
                                <span>{{ result.servicer.name }}</span><br>
                                <span>{{ result.servicer.phone|phone }}</span>
                                <span v-if="result.servicer.url"><br>
                                    <a :href="result.servicer.url" target="_blank">{{ result.servicer.url }}</a>
                                </span>
                                <span v-if="result.servicer.email"><br>
                                    <a :href="`mailto:${result.servicer.email}`" target="_blank">{{ result.servicer.email }}</a>
                                </span>
                            </p>
                        </div>
                    </div>
                    <div v-else-if="result && result == 'multiple'">
                        <p><br>Too many results found. Please enter a more specific search query.</p>
                    </div>
                    <div v-else-if="result == 'none' && !limit">
                        <p><br>
                            No results were found.</p>
                        <p>
                            We are trying our best to keep the database current. In the event you are not
                            able to locate the property on the database, please contact the county
                            Recorder's office to obtain the text of the Assignment Clause that notes an
                            association with Christiana Trust/ WSFS Institutional Services. The clause
                            should read as follows: <strong><em>“Wilmington Savings Fund Society, FSB, not in its
                            individual capacity but as Trustee for__ ___Trust”</em></strong>
                        </p>
                        <p>
                            Please contact us via our <a href="/contact-us.html" target="_blank">Contact Form</a>
                            and attach the copy of the document showing the name of the Trust. With that
                            information we will attempt to determine the Servicer and forward your request.
                            The servicer will then contact you directly. Please be advised that Wilmington
                            Savings Fund Society, FSB as Trustee is not able to influence Servicer’s
                            decision regarding a sale, a loan modification or a foreclosure of a property.
                        </p>
                    </div>
                    <div v-else-if="result == 'none' && limit">
                        <p><br>You have reached your search limit for today. Please try again tomorrow.</p>
                    </div>
                    <div class="back-btn">
                        <button class="btn" @click.prevent="result = null">Return to Search</button>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    name: 'modal-search',
    data() {
        return {
            search: {
                address: '',
                zipcode: '',
            },
            termsAgreed: false,
            submitted: false,
            result: null,
            limit: false,
        }
    },
    computed: {
    },
    methods: {
        async submit() {
            this.submitted = true
            this.limit = false
            this.$refs.form.classList.remove('invalid')
            if (!this.$refs.form.checkValidity()) {
                this.$refs.form.classList.add('invalid')
                return
            }

            let r 
            try {
                r = await axios.get('/api/property-search', 
                    {params: this.search})
            }
            catch (ex) {
                r = ex.response
            }


            if (r.status == 404) {
                this.result = 'none';
                return
            }
            else if (r.status == 300) {
                this.result = 'multiple';
                return
            }
            else if (r.status == 429) {
                this.result = 'none'
                this.limit = true
                return
            }
            else if (r.status != 200 && r.status != 300) {
                this.result = null;
                return
            }

            this.result = r.data.property
        },
        closeModal() {
            this.$emit('closed')
        }
    },
}
</script>
<style lang="scss">
#modal-search {
    form.invalid input[type=text] {
        box-shadow: 0 0 2px 2px rgb(252, 120, 0)
    }

    input[type=submit]:focus {
        box-shadow: none;
        outline: none;
    }

    input[type=submit]:active {
        opacity: 0.95;
    }

    .popup-bg {
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.375);
    }
    .modal-box {
        top: 50%;
        left: 50%;
        width: 90vw;
        max-width: 450px;
        max-height: 90vh;
        transform: translate(-50%, -50%);
        position: fixed;
        z-index: 1001;
        border-radius: 6px;
        background: white;
        overflow: auto;
        color: #111;

        form {
            margin: 20px 40px;
            input[type="submit"]{
                display:block;
                width:100%;
                margin-top:0.75rem;
                padding:0.45rem 2rem;
                border-radius:0.25rem;
                border-color:#e6c83f;
                background:linear-gradient(0deg, #e6c83f 0%,#fce88d 100%);
                color:#00375e;
                font-size:1.15rem;
                font-weight:700;
                text-align:center;
                text-transform:uppercase;
                cursor:pointer;
            }
        }

        .close {
            position: absolute;
            top: 10px;
            right: 16px;
            font-size: 0.8em;
            a {
                color: black;
                text-decoration: none;
            }
        }

        h2 {
            background: #ccc;
            color: black;
            padding: 0 0 0 40px;
            font-size: 1.1em;
            margin: 0;
            line-height: 2.2em;
        }
    }
    .search-results {
        
        a {
            color: #0e6939;

            &:hover {
                color: #258faf;
            }
        }

        h3 {
            color: black;
            margin: 1.0em 0 0 40px;
            font-size: 1.0em;
        }
        h3 .help {
            margin-left: 1.0em;
        }
        p {
            margin: 0 20px 20px 40px;
            font-size: 0.9em;
            font-weight: 500;
            a {
                text-decoration: underline;
            }
        }
        .back-btn {
            text-align: center;
            margin: 0 0 20px 0;
        }
        .property, .agent {
            margin: 0 0 1.0em 0px;
        }
    }

}
</style>
